import { Button } from "antd";
import React from "react";

const Button_v2 = ({
    className,
    text,
    children,
    ...rest
}) => {
    return (
        <Button
            className={className}
            {...rest}
        >
            {text || children}
        </Button>
    )
}

export default Button_v2;